<div id="play" class="button !opacity-100" onclick="window.app && app.voyoVideo.playClick()">
    {{ svg "play-fill" 44 "icon icon_play"}}{{ svg "pause-fill" 44 "icon icon_pause"}}
</div>
